import { render, staticRenderFns } from "./AchievementSvg.vue?vue&type=template&id=158f75a3&scoped=true"
import script from "./AchievementSvg.vue?vue&type=script&lang=js"
export * from "./AchievementSvg.vue?vue&type=script&lang=js"
import style0 from "./AchievementSvg.vue?vue&type=style&index=0&id=158f75a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158f75a3",
  null
  
)

export default component.exports